<template>
  <div class="mx--4">
    <el-skeleton
      :rows="10"
      :loading="isLoadingPages && pages.length == 0"
      animated
    >
      <el-table
        :data="pages"
        style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="p-4">
              <Details :page="props.row" />
              <el-button-group>
                <!-- <el-button
                  size="mini"
                  type="info"
                  @click="$loading(); getPageLogs(props.row).then(()=>$loading().close())"
                >
                  Histórico de mudanças
                </el-button> -->
                <el-button
                  v-if="permissions.includes('delete-page')"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="onDelete(props.row)"
                >
                  Apagar
                </el-button>
              </el-button-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Id"
          prop="id"
          width="50"
        />
        <el-table-column
          label="Título"
          prop="title"
        />
        <el-table-column
          label="Módulo"
          prop="module_name"
        />
        <el-table-column
          label="Tipo de módulo"
          prop="module_type_text"
        />
        <el-table-column
          fixed="right"
          label="Ações"
          width="220"
        >
          <template slot-scope="{ row }">
            <slot :row="row" />
          </template>
        </el-table-column>
      </el-table>
    </el-skeleton>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import RequestErrors from "@/admin/utils/RequestErrors"
export default {
  mixins: [RequestErrors],
  computed:{
    ...mapGetters(['permissions','pages','isLoadingPages']),
  },
  methods:{
    ...mapMutations(['SET_HISTORY', 'SET_PAGE']),
    ...mapActions(['deletePage', 'disablePage', 'enablePage','getPageLogs','invalidatePage']),
    onDelete(page){
      this.$confirm('Tem certeza que deseja apagar o página ?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      })
      .then(() => this.deletePage(page)
      .then(()=>this.$emit('changed')))
      .catch(() => {
        this.$message({
            type: 'info',
            message: 'Ação cancelada!'
        });
      });
    },
  }
}
</script>

